import React from "react";
import { useNavigate } from "react-router-dom";
import bgImage from "./bracu_image.jpg"; // adjust path
import logo from "./bbs_bracu_logo.png";

export default function Landing() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div
        style={{
          backgroundColor: "#ffffffeb",
          padding: "30px 20px",
          borderRadius: "10px",
          textAlign: "center",
          color: "#333",
          boxShadow: "0 8px 25px rgba(0,0,0,0.2)",
          width: "90%",
          maxWidth: "500px",
        }}
      >
        <img
          src={logo}
          alt="BRAC University Logo"
          style={{
            width: "380px",
            marginBottom: "5px",
            display: "block",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        />

        <h1 style={{ fontSize: "2.5rem", marginBottom: "30px" }}>
          BBS Faculty Portal
        </h1>
        <p style={{ marginBottom: "60px", fontSize: "1.2rem" }}>
          Access your dashboard by logging in or creating a new account.
        </p>

        <div style={{ display: "flex", justifyContent: "center", gap: "20px" }}>
          <button
            onClick={() => navigate("/login")}
            style={{
              padding: "12px 30px",
              fontSize: "1rem",
              backgroundColor: "#2654b6ff",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              color: "#fff",
              fontWeight: "bold",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
              transition: "0.3s",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#436fcfff")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#2654b6ff")}
          >
            Login
          </button>

          <button
            onClick={() => navigate("/register")}
            style={{
              padding: "12px 30px",
              fontSize: "1rem",
              backgroundColor: "#392a7dff",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              color: "#fff",
              fontWeight: "bold",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
              transition: "0.3s",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#5d4ab0ff")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#392a7dff")}
          >
            Register
          </button>
        </div>
      </div>
    </div>
  );
}
